import { React, useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { USER_LOGIN_DATA } from '../../../constants/ActionTypes';
import OrderSampleList from './OrderSampleList';

const DashboardProspect = () => {
  const dataUser = useSelector((state) => state?.auth?.userDataDetail);
  const dispatch = useDispatch();
  const [tab, setTab] = useState('Campionature');
  const [isRequestingConversion, setIsRequestingConversion] = useState(false);
  const [conversionMessage, setConversionMessage] = useState('');
  const [conversionError, setConversionError] = useState('');
  const { t } = useTranslation();
  const isMasterProspect =
    parseInt(dataUser?.parent_id) === 0 && (dataUser?.is_prospect == '1' || String(dataUser?.ACCOUNTNUM || '').startsWith('PC'));
  const hasRequestedConversion = Boolean(dataUser?.prospect_conversion_requested_at);

  const Logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userDataDetail');
    localStorage.removeItem('agentDataDetail');
    window.location.href = '/';
  };

  useEffect(() => {
    document.getElementById('home_page_class').classList.remove('home_page');
  }, []);

  const requestConversion = async () => {
    setIsRequestingConversion(true);
    setConversionMessage('');
    setConversionError('');

    try {
      const response = await axios.post(
        '/v1/prospect/request-conversion',
        {},
        {
          headers: {
            Authorization: 'Bearer ' + (dataUser?.token || localStorage.getItem('token')),
          },
        }
      );
      const result = response?.data?.result?.data;
      const updatedUser = {
        ...dataUser,
        prospect_conversion_requested_at: result?.prospect_conversion_requested_at,
      };

      dispatch({ type: USER_LOGIN_DATA, userdetailData: updatedUser });
      localStorage.setItem('userDataDetail', JSON.stringify(updatedUser));
      setConversionMessage(result?.already_requested ? t('prospect_conversion_already_requested') : t('prospect_conversion_success'));
    } catch (error) {
      setConversionError(t('prospect_conversion_error'));
    } finally {
      setIsRequestingConversion(false);
    }
  };

  return (
    <>
      <div className="main_content order_page profile_page" style={{ paddingBottom: 100 }}>
        <div className="order_section_inner container">
          <div className="order_title">
            <h1>{t('Dashboard')}</h1>
            <button onClick={() => Logout()}>{t('Logout')}</button>
          </div>
          <div className="order_detail_card">
            <div className="title_section">
              {parseInt(dataUser?.parent_id) == 0 ? (
                <>
                  <h3>{t('Dati personali')}</h3>
                  <Link to={'/profile-manage/' + dataUser.id}>{t('Richiedi modifica')}</Link>
                </>
              ) : (
                <>
                  <h3>{t('Dati personali')}</h3>
                  <span style={{ fontSize: 14, color: '#8a8a8a' }}>{t('Contatta il tuo titolare per modificare i dati')}</span>
                </>
              )}
            </div>
            {parseInt(dataUser?.parent_id) == 0 ? (
              <div className="details_section">
                <div className="row_field details">
                  <div className="data">
                    <label>{t('Ragione sociale')}</label>
                    <strong>{dataUser?.business_name}</strong>
                  </div>
                  <div className="data">
                    <label>{t('P.IVA')}</label>
                    <strong>{dataUser?.vat_number}</strong>
                  </div>
                  <div className="data">
                    <label>{t('Email')}</label>
                    <strong>{dataUser?.email}</strong>
                  </div>
                  <div className="data">
                    <label>{t('Telefono')}</label>
                    <strong>{dataUser?.mobile_no}</strong>
                  </div>
                </div>
                <div className="row_field main_address">
                  <div className="data">
                    <label>{t('Indirizzo principale')}</label>
                    <strong>{dataUser?.address}</strong>
                  </div>
                </div>
                <div className="row_field sec_address">
                  <div className="data">
                    <label>{t('Indirizzi secondari')}</label>
                  </div>
                </div>
                {isMasterProspect ? (
                  <div className="row_field" style={{ marginTop: 24 }}>
                    <div className="data" style={{ width: '100%' }}>
                      {hasRequestedConversion ? (
                        <strong style={{ color: '#455560' }}>{t('prospect_conversion_already_requested')}</strong>
                      ) : (
                        <button
                          type="button"
                          onClick={requestConversion}
                          disabled={isRequestingConversion}
                          style={{
                            border: 0,
                            background: '#455560',
                            color: '#fff',
                            padding: '12px 20px',
                            cursor: isRequestingConversion ? 'not-allowed' : 'pointer',
                          }}
                        >
                          {isRequestingConversion ? t('prospect_conversion_loading') : t('prospect_conversion_button')}
                        </button>
                      )}
                      {conversionMessage ? <p style={{ marginTop: 12, color: '#455560' }}>{conversionMessage}</p> : null}
                      {conversionError ? <p style={{ marginTop: 12, color: '#b00020' }}>{conversionError}</p> : null}
                    </div>
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="details_section">
                <div className="row_field details">
                  <div className="data">
                    <label>{t('Nome')}</label>
                    <strong>{dataUser?.fname} </strong>
                  </div>
                  <div className="data">
                    <label>{t('Cognome')}</label>
                    <strong>{dataUser?.lname}</strong>
                  </div>
                  <div className="data">
                    <label>Email</label>
                    <strong>{dataUser?.email}</strong>
                  </div>
                  <div className="data">
                    <label>{t('Telefono')}</label>
                    <strong>{dataUser?.phone}</strong>
                  </div>
                  <div className="data">
                    <label>{t('Ruolo')}</label>
                    <strong>{dataUser?.role}</strong>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="order_tab">
            <span 
              onClick={() => setTab('Campionature')} 
              className={`tab_title ${tab === 'Campionature' ? 'active' : ''}`}
            >
              {t('Campionature')}
            </span>
            <div className="tab_content order">
              <div className="content_info">
                <OrderSampleList />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardProspect;
